import { FiInfo } from "react-icons/fi";
import { BaseIconBoxProps, IconBox } from "./IconBox";

export const InfoBox = ({ children, className }: BaseIconBoxProps) => {
	return (
		<IconBox borderColor='border-blue-200' icon={FiInfo} iconFill="fill-blue-300" iconStroke="stroke-white">
			{children}
		</IconBox>
		// <div>
		// 	<div className="relative top-4">
		// 		<FiInfo size={24} className="fill-blue-300 stroke-white" />
		// 	</div>
		// 	<div
		// 		className={`mx-2 rounded-md border-2 border-blue-200 p-3 ${className}`}
		// 	>
		// 		{children}
		// 	</div>
		// </div>
	);
};
